import { Flex, Typography } from 'antd'
import type { PropsWithChildren } from 'react'

const { Title } = Typography

type Props = {
  title: string
  count?: number
} & PropsWithChildren

export const TitleSection = ({ title, count, children }: Props) => {
  return (
    <Flex justify="space-between" gap={20} wrap orientation="vertical">
      <Flex align="center" gap={4}>
        <Title level={3}>{title}</Title>

        <Title level={4}>{!!count && `(${count})`}</Title>
      </Flex>

      {children}
    </Flex>
  )
}
